import {
  Project,
  ProjectRequest,
  ProjectLite,
  ProjectFilters,
  ProjectFilter,
  NameFilter,
} from '../models/project.model';
import { StubInvoiceData } from './invoice';

export const StubProject: Project = {
  _id: '',
  versionLink: '',
  name: '',
  versionName: '',
  client: undefined,
  company: '',
  code: '',
  scope: [],
  projectJob: '',
  purpose: '',
  budgetType: '',
  service: [],
  marketSegment: '',
  estimatedCost: 0,
  actualCost: 0,
  isReal: false,
  isDraft: false,
  conditions: [],
  isApproved: false,
  isAddedToApproved: false,
  expectedBudget: 0,
  shootingDates: [],
  preparationDates: [],
  preparationDays: 0,
  jobDays: 0,
  taxPercentage: 0,
  feePercentage: 0,
  createdAt: new Date(),
  total: 0,
  shootingLocation: '',
  versionNumber: 0,
  approvedDate: new Date(),
  projectCurrency: '',
  equivalentCurrency: '',
  currencyRate: 0,
  estimateSentBy: '',
  estimateSentDate: new Date(),
  discountPercentage: 0,
  discountSpecific: 0,
  projectMedia: [],
  projectDepartments: [],
  // projectLRCategories: [],
  costItems: [],
  invoices: [StubInvoiceData],
};

export const StubProjectRequest: ProjectRequest = {
  _id: '',
  versionLink: '',
  name: '',
  client: '',
  company: '',
  code: '',
  scope: [],
  projectJob: '',
  purpose: '',
  budgetType: '',
  service: [],
  marketSegment: [],
  estimatedCost: 0,
  actualCost: 0,
  isReal: false,
  isDraft: false,
  conditions: [],
  isApproved: false,
  expectedBudget: 0,
  shootingDates: [],
  preparationDates: [],
  preparationDays: 0,
  jobDays: 0,
  taxPercentage: 0,
  feePercentage: 0,
};

export const StubProjectLite: ProjectLite = {
  _id: '',
  versionLink_: '',
  name: '',
  client: {
    _id: '',
    name: '',
  },
  scope: [],
  projectJob: '',
  service: [],
  isReal: false,
  isApproved: false,
  createdAt: new Date(),
};

export const StubProjectFilters: ProjectFilters = {
  clients: [],
  budgetTypes: [],
  projectStatuses: [],
};

export const StubNameFilter: NameFilter = {
  _id: '',
  name: '',
};

export const StubProjectFilter: ProjectFilter = {
  client: StubNameFilter,
  budgetType: '',
  company: '',
};
